export const volumes = [
  {
    number: 1,
    title: 'Siła bazowa i stabilizacja',
    tagline: 'Zbuduj mocniejsze fundamenty',
    sessions: '61 sesji',
    months: 'Miesiące 1–2',
    desc: 'Zbuduj solidne podstawy i siłę strukturalną swoich podopiecznych od pierwszego dnia.',
    bar: 'bg-blue-500',
    text: 'text-blue-400',
    border: 'border-t-blue-500',
  },
  {
    number: 2,
    title: 'Moc i transfer w treningu funkcjonalnym',
    tagline: 'Zamień siłę w moc',
    sessions: '61 sesji',
    months: 'Miesiące 3–4',
    desc: 'Rozwijaj szybkość, eksplozywność i bezpośredni transfer na realne ruchy sportowe.',
    bar: 'bg-green-500',
    text: 'text-green-400',
    border: 'border-t-green-500',
  },
  {
    number: 3,
    title: 'Wytrzymałość metaboliczna i redukcja tkanki tłuszczowej',
    tagline: 'Więcej wytrzymałości. Więcej spalania.',
    sessions: '61 sesji',
    months: 'Miesiące 5–6',
    desc: 'Spalaj tkankę tłuszczową i wynieś kondycję metaboliczną grupy na najwyższy poziom.',
    bar: 'bg-yellow-400',
    text: 'text-yellow-300',
    border: 'border-t-yellow-400',
  },
  {
    number: 4,
    title: 'Hipertrofia funkcjonalna',
    tagline: 'Więcej mięśni. Więcej funkcji.',
    sessions: '61 sesji',
    months: 'Miesiące 7–8',
    desc: 'Buduj mięśnie w funkcjonalny sposób dzięki protokołom hipertrofii dostosowanym do treningu grupowego.',
    bar: 'bg-purple-500',
    text: 'text-purple-400',
    border: 'border-t-purple-500',
  },
  {
    number: 5,
    title: 'Zwinność i sprawność sportowa',
    tagline: 'Szybciej. Dalej. Sprawniej.',
    sessions: '61 sesji',
    months: 'Miesiące 9–10',
    desc: 'Popraw koordynację, zwinność i ogólną sprawność sportową na każdym poziomie.',
    bar: 'bg-cyan-500',
    text: 'text-cyan-400',
    border: 'border-t-cyan-500',
  },
  {
    number: 6,
    title: 'Specjalizacja i wyzwania końcowe',
    tagline: 'Połącz. Wykonaj. Zamknij rok.',
    sessions: '60 sesji',
    months: 'Miesiące 11–12',
    desc: 'Sprawdź efekty całego roku dzięki wyzwaniom i testom z elementem rywalizacji.',
    bar: 'bg-red-500',
    text: 'text-red-400',
    border: 'border-t-red-500',
  },
]

export const sessionFeatures = [
  { title: 'Cel dnia', desc: 'Dokładnie wiesz, do czego zmierzasz' },
  { title: 'Gotowa rozgrzewka', desc: 'Koniec z improwizowanymi rozgrzewkami' },
  { title: '3 wersje: A/B/C', desc: 'Grupa mieszana czy osobne grupy — działa w obu przypadkach' },
  { title: 'Serie, powtórzenia i czas', desc: 'Wszystko rozpisane — zero niedomówień' },
  { title: 'Profesjonalne wyciszenie', desc: 'Każde zajęcia zamykasz w uporządkowany sposób' },
  { title: 'Wskazówka trenera', desc: 'Dopiero zaczynasz? Uczysz się. Masz doświadczenie? Potwierdzasz swoją wiedzę.' },
  { title: 'Jedna sesja na stronę', desc: 'Otwierasz, prowadzisz, gotowe' },
]

export const featureChips = [
  'Siłownia + Boks + Funkcjonalny',
  'Program na cały rok',
  'Wersje A/B/C wg poziomu',
  'Rozgrzewki i wyciszenia',
  '365 gotowych sesji',
  'Tylko podstawowy sprzęt',
]
